import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
const apiUrl = `${urlPrefix}/UnitSafetyCheck`
//#region 基本信息
const GetList = (id: number) => `${apiUrl}/GetList/${id}`
const GetInfo = (id: number) => `${apiUrl}/${id}`
const PostData = `${apiUrl}`
const PutData = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
//#endregion

export const emptyData: UnitSafetyCheckData = {
    Id: 0,
    UnitId: 0,
    CheckUnitName: '',
    CheckDate: '',
    CheckerName: '',
    UnitCheckerName: '',
    RiskLevel: 0,
    SafeCaseCount: 0,
    SafePotentialCaseCount: 0,
    SafeCheckRecord: '',
    GovCaseCount: 0,
    IllegalCorrectCaseCount: 0,
    GovCheckRecord: '',
    AcceptDoneCaseCount: 0,
    PotentialCorrectCaseCount: 0,
    CorrectCaseRecord: '',
    HasBigPotentialRisk: false,
    BigPotentialRiskCount: 0,
    BigRiskLocation: '',
    VirusPhotoComments: '',
    ImplementPlan: '',
    ExaminedUnit: '',
    CheckResult: '',
    Status: 0,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    RiskLevelName: '',
    UserName: '',
    AttachTypeVirusPhoto: 0,
    AttachGuidVirusPhoto: ''
}
export interface UnitSafetyCheckData {
    [key: string]: any
    Id: number
    UnitId: number
    CheckUnitName: string
    CheckDate: string
    CheckerName: string
    UnitCheckerName: string
    RiskLevel: number
    SafeCaseCount: number
    SafePotentialCaseCount: number
    SafeCheckRecord: string
    GovCaseCount: number
    IllegalCorrectCaseCount: number
    GovCheckRecord: string
    AcceptDoneCaseCount: number
    PotentialCorrectCaseCount: number
    CorrectCaseRecord: string
    HasBigPotentialRisk: boolean
    BigPotentialRiskCount: number
    BigRiskLocation: string
    VirusPhotoComments: string
    ImplementPlan: string
    ExaminedUnit: string
    CheckResult: string
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    RiskLevelName: string
    UserName: string
    AttachTypeVirusPhoto: number
    AttachGuidVirusPhoto: string
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const getList = (unitId: number) => {
    return tryAxios({
        method: 'get',
        url: GetList(unitId),
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id),
    })
}
export const postData = (form: UnitSafetyCheckData) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}
export const putData = (id: number, form: UnitSafetyCheckData) => {
    return tryAxios({
        method: 'put',
        url: PutData(id),
        data: form
    })
}
